import { Avatar } from "@mantine/core";

const PlusIcon = () => {
  return <Avatar size={24} src={"/assets/addIconWhite.png"} />;
};

export default PlusIcon;
